import { Outlet, useOutletContext } from "react-router-dom";
import { LayoutWrp } from "components";
import { IOutletAuth } from "types";
import { memo } from "react";

export function PrivateLayout() {
  return (
    <LayoutWrp className="layout-width">
      <Outlet context={useOutletContext<IOutletAuth>()} />
    </LayoutWrp>
  );
}

export default memo(PrivateLayout);
